export class MenuMasterItemConfigurationModel {
  MenuMasterItemId: string;
  MenuItemName: string = '';
  MenuItemCaption: string = '';
  Description: string = '';
  CommandRout: string = '';
}
